import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useAuth } from "../../providers/authprovider";

function ImageModal({ show, onHide, eventId, imageIds, currentIndex }) {
  const {
    calendar: { downloadNoteImage },
  } = useAuth();
  const [currentImageIndex, setCurrentImageIndex] = useState(currentIndex);
  const [imageSrc, setImageSrc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (show) {
      setCurrentImageIndex(currentIndex);
    }
  }, [show, currentIndex]);

  useEffect(() => {
    if (show && imageIds && imageIds.length > 0) {
      setLoading(true);
      setError(false);
      const noteId = imageIds[currentImageIndex];
      downloadNoteImage(eventId, noteId, (response) => {
        if (response.success) {
          const reader = new FileReader();
          reader.onloadend = function () {
            setImageSrc(reader.result);
            setLoading(false);
          };
          reader.onerror = function () {
            setError(true);
            setLoading(false);
          };
          reader.readAsDataURL(response.content);
        } else {
          setError(true);
          setLoading(false);
        }
      });
    }
  }, [show, currentImageIndex, imageIds, eventId]);

  const handlePrev = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? imageIds.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === imageIds.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      contentClassName="bg-black text-white"
    >
      <Modal.Body
        className="text-center"
        style={{
          backgroundColor: "black",
          padding: "1rem",
        }}
      >
        {loading && <div>Loading...</div>}
        {error && <div>Error loading image</div>}
        {!loading && !error && (
          <img
            src={imageSrc}
            alt=""
            style={{
              maxWidth: "100%",
              maxHeight: "80vh",
              objectFit: "contain",
              backgroundColor: "black",
            }}
          />
        )}
      </Modal.Body>
      <Modal.Footer
        className="justify-content-between"
        style={{ backgroundColor: "black", borderTop: "1px solid #444" }}
      >
        <Button variant="light" onClick={handlePrev}>
          Poprzednie
        </Button>
        <Button variant="light" onClick={handleNext}>
          Nastepne
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ImageModal;
